import script from "./allocationOutWarehouse.vue?vue&type=script&setup=true&lang=js"
export * from "./allocationOutWarehouse.vue?vue&type=script&setup=true&lang=js"

import "./allocationOutWarehouse.vue?vue&type=style&index=0&id=af395014&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af395014"]])

export default __exports__